function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.4102 5.39001C18.4102 6.18566 18.0941 6.94868 17.5315 7.51129C16.9689 8.0739 16.2058 8.39001 15.4102 8.39001C14.6145 8.39001 13.8514 8.0739 13.2888 7.51129C12.7262 6.94868 12.4102 6.18566 12.4102 5.39001V3.60999C12.4102 2.81434 12.7262 2.05132 13.2888 1.48871C13.8514 0.926099 14.6145 0.609985 15.4102 0.609985C16.2058 0.609985 16.9689 0.926099 17.5315 1.48871C18.0941 2.05132 18.4102 2.81434 18.4102 3.60999V5.39001Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.41016 6C8.79087 6 9.91016 4.88071 9.91016 3.5C9.91016 2.11929 8.79087 1 7.41016 1C6.02944 1 4.91016 2.11929 4.91016 3.5C4.91016 4.88071 6.02944 6 7.41016 6Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.9096 11.64C9.09344 11.0485 8.14142 10.6721 7.14143 10.5457C6.14143 10.4192 5.1257 10.5468 4.18799 10.9165C3.25028 11.2862 2.42082 11.8861 1.77619 12.661C1.13155 13.4359 0.692513 14.3606 0.499605 15.35C0.477851 15.4933 0.487519 15.6396 0.527936 15.7788C0.568354 15.9181 0.638553 16.0468 0.733674 16.1562C0.828796 16.2656 0.946563 16.353 1.07882 16.4124C1.21107 16.4717 1.35465 16.5016 1.4996 16.5H6.39961",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.4103 11.5C13.4858 11.4996 11.6257 12.193 10.171 13.453C8.71629 14.713 7.76457 16.4551 7.49032 18.36C7.47016 18.5026 7.48102 18.6478 7.52216 18.7858C7.5633 18.9237 7.63376 19.0512 7.72871 19.1595C7.82366 19.2677 7.94086 19.3542 8.07231 19.413C8.20376 19.4717 8.34635 19.5014 8.49032 19.5H22.3303C22.4743 19.5014 22.6169 19.4717 22.7483 19.413C22.8798 19.3542 22.997 19.2677 23.0919 19.1595C23.1869 19.0512 23.2573 18.9237 23.2985 18.7858C23.3396 18.6478 23.3505 18.5026 23.3303 18.36C23.0561 16.4551 22.1044 14.713 20.6497 13.453C19.195 12.193 17.3348 11.4996 15.4103 11.5Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 23.84,
  height: 20,
  fill: "white"
})));

var SvgMembers = function SvgMembers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMembers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/members.618b1521.svg";
export { ForwardRef as ReactComponent };